module.exports = __webpack_public_path__ + "img/socialMediaLinkedinGreen.e9258a86.svg";